import { useSelector, shallowEqual } from 'react-redux';

import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { useMeterType } from 'hooks/useMeterType';
import { useHasInitialState } from 'components/direct-sales/personalise-quote/hooks/useHasInitialState';

import { FUEL_OPTIONS } from 'config/app-config';

export const useEligibleFuel = () => {
  const {
    isUnsupportedElectricityMeter,
    isUnsupportedGasMeter
  } = useMeterType();
  const { fuel: hasFuelInitialState } = useHasInitialState();
  const { gas, electric } = useSelector(selectFuelType, shallowEqual);

  if (hasFuelInitialState) {
    return {
      [FUEL_OPTIONS.GAS]: !isUnsupportedGasMeter,
      [FUEL_OPTIONS.ELECTRIC]: !isUnsupportedElectricityMeter
    };
  }

  return {
    [FUEL_OPTIONS.GAS]: !isUnsupportedGasMeter && gas,
    [FUEL_OPTIONS.ELECTRIC]: !isUnsupportedElectricityMeter && electric
  };
};
